var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerveLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.354,
    height: 33.011,
    viewBox: "0 0 95.354 33.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verve_Logo",
    "data-name": "Verve Logo",
    transform: "translate(-0.724 33.389) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M16.884,33.736A16.506,16.506,0,1,1,33.389,17.23,16.505,16.505,0,0,1,16.884,33.736",
    fill: "#ed342b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M21.424,34.22c8.369-3.692,16.187-6.4,16.187-6.4v-5.66A194.24,194.24,0,0,0,15.028,32v4.43a194.211,194.211,0,0,0,22.583,9.843v-5.66s-7.818-2.707-16.187-6.4",
    transform: "translate(-11.61 -16.99)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M27.594,196.326c0-3.2-3.445-3.445-3.445-3.445v6.89s3.445-.246,3.445-3.445m-6.89,7.628V192.88s-3.692.246-3.692,5.168a19.645,19.645,0,0,0,.739,4.921l-3.937.492a17.42,17.42,0,0,1-.985-5.906c0-4.922,2.461-9.351,9.351-9.351,5.414,0,8.859,3.445,8.859,8.367,0,7.382-7.382,7.874-10.335,7.382M26.518,166.3l4.063.762s1.785-5.884-1.523-10.666H12.806v5.079H26.011c1.523,2.031.507,4.825.507,4.825m1.076-21.17c0-3.2-3.445-3.445-3.445-3.445v6.89s3.445-.246,3.445-3.445m-6.89,7.628V141.685s-3.692.246-3.692,5.167a19.647,19.647,0,0,0,.739,4.921l-3.937.492a17.422,17.422,0,0,1-.985-5.906c0-4.922,2.461-9.351,9.351-9.351,5.414,0,8.859,3.445,8.859,8.367,0,7.382-7.382,7.874-10.335,7.382m-1.686,25.936a80.265,80.265,0,0,1,12.019-3.868v-5.157a96.55,96.55,0,0,0-18.2,6.963v4.124a96.548,96.548,0,0,0,18.2,6.963v-5.157a80.281,80.281,0,0,1-12.017-3.868",
    transform: "translate(-9.849 -108.012)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerveLogo);
export default __webpack_public_path__ + "static/media/verve-logo.53afd23a405677945c18684882a822a5.svg";
export { ForwardRef as ReactComponent };